module.exports = __webpack_public_path__ + "img/24.4fea48d1.svg";